import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-app-platform-not-supported",
	templateUrl: "./platform-not-supported.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class PlatformNotSupportedComponent {}
